export default __webpack_public_path__ + "static/media/64.c4e8142f.mp3";